// Horizontal gap between cards (increased for better visual balance with zig-zag)
export const CARD_GAP = 70;

// Vertical offset for alternating rows (creates zig-zag effect)
export const VERTICAL_OFFSET = 150;

// Base Y position from top
export const BASE_Y_POSITION = 200;

// X offset for odd-indexed cards (shifts them left to balance visual spacing)
export const ODD_X_OFFSET = 15;

// Slide-in animation constants
export const STAGGER_DELAY = 12;
export const ANIMATION_START_FRAME = 10;

// Flip animation constants
export const FLIP_START_DELAY = 30;
export const FLIP_STAGGER_DELAY = 8;

// Phase transition constants
export const PHASE_1_MAX_CARDS = 3;
export const PHASE_FLIP_TO_HOLD_BUFFER = 20;
export const HOLD_DURATION = 40;
export const EXIT_STAGGER_DELAY = 6;
export const EXIT_DURATION = 25;

// Category transition gap (frames between categories)
export const CATEGORY_TRANSITION_GAP = 10;

// Card dimensions
export const CARD_WIDTH = 380;
export const CARD_HEIGHT = 510;

// Slide-in animation constants
export const SLIDE_DISTANCE = 1200;

// Category label animation constants
export const LABEL_SLIDE_DISTANCE = 200;
export const LABEL_EXIT_LEAD_FRAMES = 10;
